import { Navigate, useLocation } from 'react-router-dom';

export function RedirectPreserveSearch({ to }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}
